const EventNames = {
  HOME_TAB_OPENED: 'Home_Tab_Opened',
  PROMOTIONAL_BANNER_CLICKED: 'Promotional_Banner_Clicked',
  PROMOTIONAL_PAGE_VIEWED: 'Promotional_Page_Viewed',
  PROMOTIONAL_EVENT_REGISTER: 'Promotional_Event_Register',
  PROMOTIONAL_EVENT_STARTED: 'Promotional_Event_Started',
  FREE_VIDEO_CLICKED: 'Free_Video_Clicked',
  FREE_QUIZ_STARTED: 'Free_Quiz_Started',
  FREE_QUIZ_LANGUAGE_SWITCHED: 'Free_Quiz_Language_Switched',
  FREE_QUIZ_SUBMITTED: 'Free_Quiz_Submitted',
  QUICK_LINK_CLICKED: 'Quick_Link_Clicked',
  COURSE_CARD_CLICKED: 'Course_Card_Clicked',
  COURSE_DETAILS_VIEWED: 'Course_Details_Viewed',
  COURSE_LIST_VIEWED: 'Course_List_Viewed',
  BROCHURE_DOWNLOADED: 'Brochure_Downloaded',
  BATCH_SELECTED: 'Batch_Selected',
  ENROLL_NOW_CLICKED: 'Enroll_Now_Clicked',
  COMBO_SELECTED: 'Combo_Selected',
  COMBO_ENROLL_NOW_CLICKED: 'Combo_Enroll_Now_Clicked',
  REQUEST_CALLBACK_CLICKED: 'Request_Callback_Clicked',
  FILTER_APPLIED: 'Filter_Applied',
  COURSES_SEARCH_INITIATED: 'Courses_Search_Initiated',
  PODCAST_STARTED: 'Podcast_Started',
  LIVE_CLASS_STARTED: 'Live_Class_Started',
  //  DEMO_CLASS_STARTED:"Demo_Class_Started",

};

export default EventNames;
